import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { isPushEnabled, firePushNotification } from "@/lib/watchlist";

const LS_KEY = "ns_opening_bell_seen";

/**
 * Polls /api/opening-bell/latest. On a new daily snapshot (generated_at changed),
 * if push is enabled we fire a native browser Notification with Market Momentum + top mover.
 */
export default function OpeningBellRunner() {
  const seen = useRef((typeof window !== "undefined") ? (localStorage.getItem(LS_KEY) || "") : "");
  const [go, setGo] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGo(true), 4000);
    return () => clearTimeout(t);
  }, []);
  const { data } = useQuery({
    queryKey: ["opening-bell"],
    queryFn: async () => (await api.get("/opening-bell/latest")).data,
    refetchInterval: 2 * 60_000,
    enabled: go,
  });

  useEffect(() => {
    const snap = data?.data;
    if (!snap) return;
    const generatedAt = snap.generated_at || snap.ts;
    if (!generatedAt || generatedAt === seen.current) return;
    seen.current = generatedAt;
    try { localStorage.setItem(LS_KEY, generatedAt); } catch (_) {}
    if (!isPushEnabled()) return;
    const topGainer = (snap.top_gainers || [])[0];
    const topLoser = (snap.top_losers || [])[0];
    const body = topGainer
      ? `${snap.zone} · Score ${Math.round(snap.score)}/100 · Top: ${topGainer.name} ${topGainer.change_pct >= 0 ? '+' : ''}${Number(topGainer.change_pct).toFixed(2)}%`
      : `${snap.zone} · Score ${Math.round(snap.score)}/100`;
    firePushNotification(
      "Opening Bell · 9:14 AM IST",
      body,
      "/"
    );
    // Fire a secondary "losers" summary so readers see both sides.
    if (topLoser) {
      setTimeout(() => {
        firePushNotification(
          "Street weakness today",
          `${topLoser.name} ${Number(topLoser.change_pct).toFixed(2)}% — tap for the Sector Heatmap`,
          "/"
        );
      }, 4000);
    }
  }, [data]);

  return null;
}
